import React from 'react';
export function FinalCTA() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-[#1a2e1a] text-center border-t border-green-800/40" data-id="element-43">
      <div className="max-w-3xl mx-auto" data-id="element-44">
        <div className="text-5xl mb-8" data-id="element-45">⏳</div>

        <h2 className="font-heading text-3xl md:text-5xl font-bold mb-6 leading-tight text-[#faf5e8]" data-id="element-46">
          Porque si no cambiás esto…
          <br data-id="element-47" />
          <span className="text-[#a8c5a8]" data-id="element-48">El próximo partido…</span>
          <br data-id="element-49" />
          va a ser exactamente igual.
        </h2>

        <p className="text-2xl md:text-3xl text-[#c8e6c9] font-bold mb-12 mt-8" data-id="element-50">
          👉 Entrá ahora.
          <br data-id="element-51" />Y empezá a entrenar como jugás.
        </p>

        <a href="https://checkout.ebookpoint.shop/cart/59423210209361:1" className="inline-block bg-[#c8e6c9] hover:bg-[#a5d6a7] text-[#1a2e1a] font-heading font-black text-xl md:text-2xl py-5 px-10 rounded-full shadow-[0_0_20px_rgba(200,230,201,0.2)] transition-all transform hover:scale-105 uppercase tracking-wider" data-id="element-52">
          Acceder al Sistema
        </a>
      </div>
    </section>;
}